import BackendError from "../BackendError";
import {ThreeDots} from "@dvrt/graphql-widgets";
import RedirectToError from "../RedirectToError";
import {useDomainNameQuery} from "@/queries.generated";

export default function DomainNameShard({id}: {id: number}) {
    const {loading, error, data} = useDomainNameQuery({
        variables: {id: id},
    });

    if (loading) return <ThreeDots height={5} />;

    if (error) return <BackendError error={error} />;

    if (data.domains.items.length !== 1) return <RedirectToError id="unknown_domain" />;

    return <span>{data.domains.items[0].name}</span>;
}
